import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import IdentitySection from "./components/IdentitySection";
import StrategySection from "./components/StrategySection";
import BusinessSection from "./components/BusinessSection";
import AdvantageSection from "./components/AdvantageSection";
import RoadmapSection from "./components/RoadmapSection";
import CareersSection from "./components/CareersSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <IdentitySection />
        <StrategySection />
        <BusinessSection />
        <AdvantageSection />
        <RoadmapSection />
        <CareersSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
